import { desktop } from './desktop';

/** The desktop app's global shortcuts as Electron accelerators, e.g. "Shift+Command+M"; the app checks them again (apps/desktop/src/call.ts). */
const mac = desktop ? desktop.platform === 'darwin' : /Mac|iPhone|iPad/.test(navigator.platform);

const MAC_SYMBOLS: Record<string, string> = { Control: '⌃', Alt: '⌥', Shift: '⇧', Command: '⌘', CommandOrControl: '⌘' };

/** "⇧⌘M" on a Mac, "Ctrl + Shift + M" elsewhere. */
export function formatShortcut(accelerator: string): string {
  const parts = accelerator.split('+');
  if (mac) return parts.map((part) => MAC_SYMBOLS[part] ?? part).join('');
  return parts.map((part) => (part === 'Control' || part === 'CommandOrControl' ? 'Ctrl' : part)).join(' + ');
}

const MODIFIER_KEYS = new Set(['Shift', 'Control', 'Alt', 'Meta', 'AltGraph', 'CapsLock', 'Fn']);
const FUNCTION_KEY = /^F([1-9]|1\d|2[0-4])$/;

/**
 * Reads a key press as an accelerator, by the key's place on the keyboard so a Turkish layout gets
 * the same keys as the desktop app registers. Null while only modifiers are held.
 */
export function readShortcut(event: KeyboardEvent): { accelerator: string } | { problem: string } | null {
  if (MODIFIER_KEYS.has(event.key)) return null;
  const key = /^Key[A-Z]$/.test(event.code) ? event.code.slice(3) : /^Digit\d$/.test(event.code) ? event.code.slice(5) : FUNCTION_KEY.test(event.code) ? event.code : null;
  if (!key) return { problem: 'Bir harf, rakam ya da F tuşu seç.' };
  if (event.metaKey && !mac) return { problem: 'Windows tuşu kısayolda kullanılamaz.' };
  // Windows reads Ctrl+Alt as AltGr, which types characters such as @ on a Turkish keyboard.
  if (event.ctrlKey && event.altKey && !mac) return { problem: 'Ctrl + Alt, AltGr ile aynı sayılır ve @ gibi karakterleri yazmayı engeller. Başka bir birleşim seç.' };
  const modifiers = [event.ctrlKey && 'Control', event.altKey && 'Alt', event.shiftKey && 'Shift', event.metaKey && 'Command'].filter((m): m is string => !!m);
  if (!FUNCTION_KEY.test(key) && !modifiers.some((m) => m !== 'Shift')) {
    return { problem: mac ? '⌘, ⌥ ya da ⌃ ile birlikte bas.' : 'Ctrl ya da Alt ile birlikte bas.' };
  }
  return { accelerator: [...modifiers, key].join('+') };
}
